import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reduceNotes } from '../../actions/policy/reduceNotes';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* upsertNoteSaga(action) {
    try {
        yield put(reduceLoading({ code: 'upsertNote', value: true }));

        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const body = JSON.stringify({
            policyTransactionGuid: entity,
            ...action.payload,
        });

        const response = yield call(fetch, '/api/policyTransaction/notes/upsert', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body,
        });

        const result = yield call([response, 'json']);

        yield put(reduceOperation(result.operation));

        if (result.operation?.status) {
            yield put(reduceNotes(result.notes));
        }
    } catch (error) {
        console.log('Error while calling Upsert Note API - ', error);
    } finally {
        yield put(reduceLoading({ code: 'upsertNote', value: false }));
    }
}
